import React from 'react';

import { useEffect } from 'react';

import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import { FormGroup } from 'react-bootstrap';
import { FormLabel } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

import SubjectMatterCategoryStore from '../../../stores/SubjectMatterCategoryStore';

const SubjectMatterCategoryEditPage = ({ users }) => {
    const navigate = useNavigate();

    const store = SubjectMatterCategoryStore((state) => state);

    //useParams returns strings, so we convert it to a number here
    const subjectMatterCategoryId = Number(useParams().subjectMatterCategoryId);

    useEffect(() => {
        store.load(subjectMatterCategoryId);
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    if (null == store.subjectMatterCategory) {
        return <div>Loading ...</div>;
    }

    const getFormInputComponent = function (
        subjectMatterCategory,
        attributeName,
    ) {
        switch (attributeName) {
            case 'id':
                return (
                    <FormGroup
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>ID</FormLabel>
                        <FormControl
                            type="text"
                            readOnly
                            disabled
                            value={subjectMatterCategory.id}
                        />
                    </FormGroup>
                );

            case 'category':
                return (
                    <FormGroup
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>
                            Label<span className="text-danger">*</span>
                        </FormLabel>

                        <FormControl
                            type="text"
                            value={subjectMatterCategory.category}
                            onChange={(e) => {
                                store.updateAttribute(
                                    'category',
                                    e.target.value,
                                );
                            }}
                        />
                    </FormGroup>
                );

            default:
                return null;
        }
    };

    var formInputElements = [];

    formInputElements.push(
        getFormInputComponent(store.subjectMatterCategory, 'id'),
    );
    formInputElements.push(
        getFormInputComponent(store.subjectMatterCategory, 'category'),
    );

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('/subjectMatterCategory/');
                        }}
                    >
                        Back to list
                    </Button>
                    <div>SubjectMatterCategory Edit Page</div>
                    <br />
                    <form>
                        {formInputElements}

                        <br />
                        <br />

                        <Button
                            onClick={() => {
                                navigate('/subjectMatterCategory');
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                store.update(
                                    store.subjectMatterCategory,
                                    () => {
                                        alert('Your edits were saved');
                                        navigate('/subjectMatterCategory');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Save
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                store.delete(
                                    store.subjectMatterCategory.id,
                                    () => {
                                        alert(
                                            'The subjectMatterCategory was deleted',
                                        );
                                        navigate('/subjectMatterCategory');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Delete
                        </Button>
                    </form>
                </Col>
            </Row>
        </Container>
    );
};

export default SubjectMatterCategoryEditPage;
